import React, {useMemo} from 'react';
import {Table, TableColumn} from 'tea-component';
import {useDblIntl} from '@/pages/datalab/utils/utils';
import SortTable from '@/pages/datalab/components/CustomComponents/SortTable';

import Abnormal from '@/pages/home/components/Abnormal';

import './index.scss';
import {FormColumnType} from '../_type';

const { scrollable, autotip } = Table.addons;
const RightSqlTable = (props: any) => {
  const { tableData, loading, error } = props;
  const { commonFormatMessage, isEn } = useDblIntl('');

  const { columns, records } = useMemo(() => {
    const columns: TableColumn[] = [];
    (tableData?.columns || []).forEach((column: FormColumnType, key) => {
      columns.push({
        key: column?.column_name,
        header: column.column_name || '-',
        width: 180,
        // align: column.type === 0 ? 'right' : 'left',
        align: key === 0 ? 'left' : 'right',
        render(record) {
          if (record?.[column?.column_name] === null) {
            return '-';
          }
          return record?.[column?.column_name];
        }
      });
    });
    
    return {
      columns,
      records: tableData?.data ? tableData?.data : [], // 为了避免20231108这种日期被增加了千分隔符, 需求修改为直接展示后端返回的数据, 前端不做格式处理
    };
  }, [tableData, loading, isEn]);

  const configs = [
    autotip({
      isLoading: loading,
      isError: error,
      emptyText: (
        <span className="dbl-loading-failed-nodata" title={commonFormatMessage("no_data")}>
          {commonFormatMessage("no_data")}
        </span>
      ),
      loadingText: (
        <span className="dbl-loading-failed-nodata" title={commonFormatMessage("loading")}>
          {commonFormatMessage("loading")}
        </span>
      ),
      errorText: (
        <span className="dbl-loading-failed-nodata" title={commonFormatMessage("load_fail")}>
          {commonFormatMessage("load_fail")}
        </span>
      ),
    })
  ];

  records.length > 6 && configs.push(scrollable({
    virtualizedOptions: {
      height: 268,
      itemHeight: 40,
      onScrollBottom: () => console.log("Bottom"),
    },
    maxHeight: '100%',
    scrollToTopOnChange: true,
  }));

  return (
    <div className="dbl-drag-sql0-edit-table">
      <Abnormal
        style={{height: 318}}
        isLoading={loading}
        isError={error}
        nodataMsg={commonFormatMessage("no_data")}
        isNoData={records?.length === 0}
        component={<SortTable
          columns={columns}
          records={(loading || error) ? [] : records}
          loading={false}
          error={false}
          addonsConfig={configs}
        />}
      />


    </div>
  );
};

export default RightSqlTable;
